/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const recalculateCollectionCountsV1ResultSchema = z.object({
  recalculated: z.number(),
});

export type IRecalculateCollectionCountsV1Result = z.infer<
  typeof recalculateCollectionCountsV1ResultSchema
>;

export const recalculateCollectionCountsV1ResponseSchema = createApiResponseSchema(
  recalculateCollectionCountsV1ResultSchema,
) as z.ZodSchema<IAPI<IRecalculateCollectionCountsV1Result>>;

export type IRecalculateCollectionCountsV1Response = IAPI<IRecalculateCollectionCountsV1Result>;
